export default "__VITE_ASSET__C7S9OM2A__"